module.exports = __webpack_public_path__ + "static/media/top_square2.b9d3fc7c.svg";